import { IModel, TabularTypeDataset } from 'shell-models-lib';
import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';
import { PostgreSqlLinkedService } from 'app/model/linkedservice/postgre-sql.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.postgreSql.datasetType,
    disabled: __IS_FABRIC_DPE__,
    display: [
        format(stringResources.ModelName_DatasetTemplate, getConnectorLegacyNameByFlag(stringResources.PostgreSql_DisplayText, true)),
        format(stringResources.ModelName_DatasetsTemplate, getConnectorLegacyNameByFlag(stringResources.PostgreSql_DisplayText, true))
    ],
    constraints: {
        linkedService: {
            model: PostgreSqlLinkedService.MODEL // Linked service redefined
        }
    }
})
export class PostgreSqlDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}
